/*
 * ARTSY FARTSY - ramme og indramningsservice som tilkoeb
 * ------------------------------------------------------------------
 * Denne fil erstatter de aendringer der i Stiletto 3.4.1 var skrevet
 * direkte ind i temaets egen assets/theme.js. Her ligger de for sig selv,
 * saa en temaopdatering ikke sletter dem igen.
 *
 * Hvad filen goer:
 *
 * 1. Produktsiden (rammevaelgeren, snippets/product-block-frame-picker.liquid)
 *    - Klik paa en ramme vaelger den og tegner rammen rundt om produktbilledet.
 *    - Naar kunden skifter stoerrelse/materiale, vises kun de rammer og den
 *      indramningsservice der passer til den valgte variant.
 *    - Indramningsservicen vises foerst naar der er valgt en ramme.
 *
 * 2. Laeg i kurv
 *    Naar kunden trykker "Tilfoej til kurv" med en ramme valgt, laegges
 *    plakat, ramme og evt. service i kurven som tre linjer, der er bundet
 *    sammen med linjeegenskaber:
 *      plakat:  _bundle_id = plakatens SKU
 *      ramme:   poster = plakatlinjens titel, _bundle_id
 *      service: poster, frame = rammelinjens titel, _bundle_id
 *    Pakkeseddel, royalty og ordresortering laeser disse egenskaber - de
 *    maa ikke omdoebes.
 *
 * 3. Fjern fra kurv
 *    Fjernes plakaten, fjernes dens ramme og service ogsaa. Fjernes rammen,
 *    fjernes dens service.
 *
 * Teknik: temaet sender sine kald til /cart/add.js og /cart/change.js med
 * fetch. Filen lytter paa de kald i stedet for at rette i temaets kode.
 * Temaet faar det svar det forventer og opdaterer kurven som normalt.
 */
(function () {
  'use strict';

  if (window.__artsyAddons) return;
  window.__artsyAddons = true;

  var SEL = {
    picker: '[data-frame-picker]',
    frameInput: 'input[data-addon-product-id]',
    serviceInput: 'input[data-addon-service-id]',
    frameButton: '.product-block--frame-button',
    frameSelected: '.product-block--frame-selected',
    serviceWrapper: '.product-block--service-wrapper',
    serviceRow: '.product-block--service',
    serviceCheckbox: '.addon-service--input',
    variantSelect: '[data-variant-select]',
    mediaMobile: '.product__media-container.below-mobile .product__media-item .media',
    mediaDesktop: '.product__media-container.above-mobile .product__media-item .media'
  };

  /* ---------- hjaelpere ---------- */

  function productContainer(el) {
    return (
      el.closest('[data-section-type="product"]') ||
      el.closest('.quick-product') ||
      el.closest('[data-product-form]') ||
      el.closest('.shopify-section') ||
      document
    );
  }

  function formatMoney(cents) {
    cents = parseInt(cents, 10);
    if (isNaN(cents)) return '';
    var format = (window.theme && window.theme.moneyFormat) || '{{amount}}';
    var value = (cents / 100).toFixed(2);
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var parts = value.split('.');
    var whole = parts[0];
    var dec = parts[1];
    var out;
    switch (key) {
      case 'amount_no_decimals':
        out = (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        break;
      case 'amount_with_comma_separator':
        out = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + dec;
        break;
      case 'amount_no_decimals_with_comma_separator':
        out = (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        break;
      case 'amount_with_apostrophe_separator':
        out = whole.replace(/\B(?=(\d{3})+(?!\d))/g, "'") + '.' + dec;
        break;
      default:
        out = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + dec;
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  function currentVariantId(container) {
    var select = container.querySelector(SEL.variantSelect);
    if (select && select.value) return String(select.value);
    var input = container.querySelector('[data-product-form] input[name="id"], form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return String(input.value);
    var fromUrl = new URLSearchParams(window.location.search).get('variant');
    return fromUrl ? String(fromUrl) : '';
  }

  function variantSkus(container) {
    var el = container.querySelector('script[data-artsy-variant-skus]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent) || {};
    } catch (e) {
      return {};
    }
  }

  /* ---------- rammen paa produktbilledet ---------- */

  function applyFrameToMedia(el, frameImg, addonId) {
    if (!el) return;
    if (!addonId || !frameImg) {
      el.classList.remove('media-with-frame');
      el.classList.remove('media-with-canvas');
      el.style.borderImageSource = '';
      return;
    }
    el.classList.add('media-with-frame');
    el.style.borderImageSource = 'url(' + frameImg + ')';
    el.classList.toggle('media-with-canvas', String(frameImg).toLowerCase().indexOf('canvas') > -1);
  }

  function onFrameChange(container) {
    var input = container.querySelector(SEL.frameInput);
    if (!input) return;
    var addonId = input.value;
    var frameImg = '';
    var frameTitle = '';

    container.querySelectorAll(SEL.frameButton).forEach(function (btn) {
      if (btn.getAttribute('data-addon-id') !== addonId) {
        btn.classList.remove('selected-addon');
        return;
      }
      btn.classList.add('selected-addon');
      var title = btn.getAttribute('data-addon-title');
      var border = btn.getAttribute('data-addon-border');
      if (border) frameImg = border;
      if (title && btn.getAttribute('data-addon-price')) {
        frameTitle =
          title +
          ' ( ' +
          formatMoney(btn.getAttribute('data-addon-price')) +
          ' <s>' +
          formatMoney(btn.getAttribute('data-addon-compare-price')) +
          '</s> )';
      }
    });

    var selectedEl = container.querySelector(SEL.frameSelected);
    if (selectedEl) selectedEl.innerHTML = frameTitle;

    applyFrameToMedia(container.querySelector(SEL.mediaMobile), frameImg, addonId);
    applyFrameToMedia(container.querySelector(SEL.mediaDesktop), frameImg, addonId);

    var serviceWrapper = container.querySelector(SEL.serviceWrapper);
    if (serviceWrapper) serviceWrapper.classList.toggle('hidden', !addonId);
  }

  function setFrame(container, addonId) {
    var input = container.querySelector(SEL.frameInput);
    if (!input) return;
    input.value = addonId || '';
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function setService(container, serviceId) {
    var input = container.querySelector(SEL.serviceInput);
    if (!input) return;
    input.value = serviceId || '';
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function updateForVariant(container, variantId) {
    if (!container.querySelector(SEL.frameInput)) return;
    variantId = String(variantId || '');

    setFrame(container, '');
    container.querySelectorAll(SEL.frameButton).forEach(function (btn) {
      var v = btn.getAttribute('data-variant-id');
      if (v) btn.classList.toggle('hidden', v !== variantId);
    });

    setService(container, '');
    container.querySelectorAll(SEL.serviceCheckbox).forEach(function (cb) {
      cb.checked = false;
    });
    container.querySelectorAll(SEL.serviceRow).forEach(function (row) {
      var v = row.getAttribute('data-variant-id');
      if (v) row.classList.toggle('hidden', v !== variantId);
    });
  }

  function initPicker(picker) {
    var container = productContainer(picker);
    if (container.__artsyAddonsReady) return;
    container.__artsyAddonsReady = true;

    var frameInput = container.querySelector(SEL.frameInput);
    if (!frameInput) return;

    frameInput.addEventListener('change', function () {
      onFrameChange(container);
    });

    container.addEventListener('click', function (e) {
      var btn = e.target.closest(SEL.frameButton);
      if (!btn || !container.contains(btn)) return;
      e.preventDefault();
      setFrame(container, btn.getAttribute('data-addon-id') || '');
    });

    container.addEventListener('change', function (e) {
      var cb = e.target.closest && e.target.closest(SEL.serviceCheckbox);
      if (!cb) return;
      var id = (cb.getAttribute('id') || '').replace('addon-service--', '');
      setService(container, cb.checked ? id : '');
    });

    var lastVariant = currentVariantId(container);
    updateForVariant(container, lastVariant);

    // Temaet sender product:variant-change (useCustomEvents i theme-globals).
    // Som ekstra sikkerhed holdes der ogsaa oeje med variant-feltet.
    var select = container.querySelector(SEL.variantSelect);
    function check() {
      var v = currentVariantId(container);
      if (v && v !== lastVariant) {
        lastVariant = v;
        updateForVariant(container, v);
      }
    }
    if (select) select.addEventListener('change', check);
    document.addEventListener('product:variant-change', function () {
      setTimeout(check, 0);
    });
    container.__artsyCheckVariant = check;
  }

  function initAll() {
    document.querySelectorAll(SEL.picker).forEach(initPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('quickview:loaded', initAll);

  /* ---------- laeg i kurv: plakat + ramme + service ---------- */

  var pending = null;

  function rememberAddToCart(el) {
    var container = productContainer(el);
    var frameInput = container.querySelector(SEL.frameInput);
    if (!frameInput || !frameInput.value) {
      pending = null;
      return;
    }
    var serviceInput = container.querySelector(SEL.serviceInput);
    var variantId = currentVariantId(container);
    var qtyInput = container.querySelector('[data-product-form] input[name="quantity"], input[name="quantity"]');
    pending = {
      at: Date.now(),
      frameId: frameInput.value,
      serviceId: serviceInput ? serviceInput.value : '',
      variantId: variantId,
      sku: variantSkus(container)[variantId] || '',
      quantity: Math.max(1, parseInt((qtyInput && qtyInput.value) || '1', 10) || 1)
    };
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (form && form.matches && form.matches('form[action*="/cart/add"]')) rememberAddToCart(form);
    },
    true
  );
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('[data-add-to-cart]');
      if (btn) rememberAddToCart(btn);
    },
    true
  );

  var nativeFetch = window.fetch.bind(window);

  function urlOf(input) {
    return typeof input === 'string' ? input : input && input.url ? input.url : String(input);
  }

  function withBundleId(body, sku) {
    if (!sku || body == null) return body;
    if (typeof body === 'string') {
      if (body.trim().charAt(0) === '{') {
        try {
          var data = JSON.parse(body);
          if (data.items && data.items[0]) {
            data.items[0].properties = Object.assign({}, data.items[0].properties, { _bundle_id: sku });
          } else {
            data.properties = Object.assign({}, data.properties, { _bundle_id: sku });
          }
          return JSON.stringify(data);
        } catch (e) {
          return body;
        }
      }
      var params = new URLSearchParams(body);
      params.set('properties[_bundle_id]', sku);
      return params.toString();
    }
    if (body instanceof FormData) {
      body.set('properties[_bundle_id]', sku);
      return body;
    }
    if (body instanceof URLSearchParams) {
      body.set('properties[_bundle_id]', sku);
      return body;
    }
    return body;
  }

  function postJSON(path, data) {
    return nativeFetch(path, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) {
      return r.json();
    });
  }

  function addWithAddons(input, init, job) {
    var nextInit = Object.assign({}, init, { body: withBundleId(init.body, job.sku) });

    return nativeFetch(input, nextInit).then(function (res) {
      if (!res.ok) return res;

      return res
        .clone()
        .json()
        .then(function (data) {
          var item = data && data.items ? data.items[0] : data;
          var posterTitle = item && item.title;
          if (!posterTitle) return res;

          var frameProps = { poster: posterTitle };
          if (job.sku) frameProps._bundle_id = job.sku;

          return postJSON('/cart/add.js', {
            items: [{ id: Number(job.frameId), quantity: job.quantity, properties: frameProps }]
          })
            .then(function (frameRes) {
              var frameItem = frameRes && frameRes.items && frameRes.items[0];
              if (!job.serviceId || !frameItem) return;
              var serviceProps = { poster: posterTitle, frame: frameItem.title };
              if (job.sku) serviceProps._bundle_id = job.sku;
              return postJSON('/cart/add.js', {
                items: [{ id: Number(job.serviceId), quantity: job.quantity, properties: serviceProps }]
              });
            })
            .catch(function (err) {
              console.error('[ARTSY] Ramme/service kunne ikke laegges i kurven', err);
            })
            .then(function () {
              return res;
            });
        })
        .catch(function () {
          return res;
        });
    });
  }

  /* ---------- fjern fra kurv: tag ramme og service med ---------- */

  function props(item) {
    return item.properties || {};
  }
  function isFramingService(item) {
    var p = props(item);
    return !!(p.poster && p.frame);
  }
  function isFrame(item) {
    var p = props(item);
    return !!(p.poster && !p.frame);
  }
  function linkedTo(cart, item) {
    if (isFramingService(item)) return [];
    if (isFrame(item)) {
      var posterTitle = props(item).poster;
      return cart.items.filter(function (i) {
        return isFramingService(i) && props(i).frame === item.title && (!posterTitle || props(i).poster === posterTitle);
      });
    }
    return cart.items.filter(function (i) {
      return i.key !== item.key && props(i).poster === item.title;
    });
  }

  function removeWithLinked(input, init) {
    var data;
    try {
      data = typeof init.body === 'string' ? (init.body.trim().charAt(0) === '{' ? JSON.parse(init.body) : Object.fromEntries(new URLSearchParams(init.body))) : null;
    } catch (e) {
      data = null;
    }
    if (!data || Number(data.quantity) !== 0) return nativeFetch(input, init);

    return nativeFetch('/cart.js', { credentials: 'include' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var item = null;
        if (data.line) item = cart.items[Number(data.line) - 1];
        else if (data.id) {
          item = cart.items.filter(function (i) {
            return String(i.key) === String(data.id) || String(i.variant_id) === String(data.id) || String(i.id) === String(data.id);
          })[0];
        }
        if (!item) return nativeFetch(input, init);
        var linked = linkedTo(cart, item);
        if (!linked.length) return nativeFetch(input, init);

        var updates = {};
        updates[item.key] = 0;
        linked.forEach(function (i) {
          updates[i.key] = 0;
        });
        return nativeFetch('/cart/update.js', {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .catch(function () {
        return nativeFetch(input, init);
      });
  }

  window.fetch = function (input, init) {
    init = init || {};
    var method = String(init.method || (input && input.method) || 'GET').toUpperCase();
    if (method === 'POST') {
      var url = urlOf(input);
      var path;
      try {
        path = new URL(url, window.location.origin).pathname.replace(/\/+$/, '');
      } catch (e) {
        path = '';
      }
      if (/\/cart\/add(\.js)?$/.test(path) && pending && Date.now() - pending.at < 8000) {
        var job = pending;
        pending = null;
        return addWithAddons(input, init, job);
      }
      if (/\/cart\/change(\.js)?$/.test(path)) {
        return removeWithLinked(input, init);
      }
    }
    return nativeFetch(input, init);
  };
})();
